import global from "../styles";
import classNames from "classnames";

export const formatHeaderWords = (header, usePaddingLeft) =>
  header.split(" ").map((word) => (
    <span
      aria-hidden
      className={classNames(global.headerWordWrapper, {
        [global.headerWordWrapperPaddingLeft]: usePaddingLeft,
      })}
      key={word}
    >
      {word}
    </span>
  ));
